import { useCallback, useMemo, useState } from "react";
import { useAuth } from "../../../auth/useAuth";
import { getCompany } from "../network";
import { TCompany } from "../models";
import {
  clearLocalData,
  setLocalData,
} from "../../../utils/lLocalCompanyDataActions";

export const useCompanyAuth = (
  commonCompanyId?: string
): [
  string,
  boolean,
  Error | null,
  (companyId?: string) => void,
  boolean, // Authorized
  (item: TCompany | null, companyId?: string) => void,
  (companyId: string) => void
] => {
  const { authorizedCompanyId, setAuthorizedCompanyId } = useAuth();
  const [result, setResult] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(
    async (companyId?: string) => {
      companyId = companyId || commonCompanyId;

      if (!companyId) {
        setError(new Error("Company Id not provided"));
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        setResult("");
        // const response = await authToCompany(companyId);
        // setTokenData({
        //   ...response,
        //   companyId,
        // });
        setAuthorizedCompanyId(companyId);
        setTimeout(() => setResult(companyId!), 0);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error("Unknown error"));
        }
      }
      setIsLoading(false);
    },
    [setAuthorizedCompanyId, commonCompanyId]
  );

  const authHandler = (item: TCompany | null, companyId?: string) => {
    if (item === null) {
      clearLocalData();
      setAuthorizedCompanyId("");
    } else {
      setLocalData(item);
      request(companyId);
    }
  };

  const authHandlerToAnotherCompany = async (companyId: string) => {
    const item = await getCompany(companyId);
    authHandler(item, companyId);
  };

  const isAuthorized: boolean = useMemo(() => {
    if (commonCompanyId && commonCompanyId === authorizedCompanyId) {
      return true;
    }
    return false;
  }, [commonCompanyId, authorizedCompanyId]);

  return [
    result,
    isLoading,
    error,
    request,
    isAuthorized,
    authHandler,
    authHandlerToAnotherCompany,
  ];
};
